export const defaultHackerAllSelector = (state) =>
  state?.defaultHackerReducer?.defaultHackerAll;
